import React, { useMemo } from 'react';
import './App.css';
import 'diana-v2-mobiscroll/dist/css/mobiscroll.react.min.css';
import { Outlet } from 'react-router-dom';
import { DianaCoreProvider, useThemeStore } from '@diana/core';
import { createAppTheme } from '@diana/mui';
import useAuthService, { AuthContext } from '../hooks/auths/useAuthService';

function App() {
  const primaryColor = '#1d82c0';
  const themeName = useThemeStore((store) => store.themeName);
  const setTheme = useThemeStore((state) => state.setTheme);
  const theme = useMemo(() => {
    setTheme(themeName);
    return createAppTheme({ themeName, primaryColor });
  }, [primaryColor, themeName, setTheme]);

  const { isAuthenticated, login, logout, getAccessToken } = useAuthService();

  const authContextValue = useMemo(
    () => ({
      isAuthenticated,
      login,
      logout,
      getAccessToken,
    }),
    [isAuthenticated, login, logout, getAccessToken],
  );

  return (
    <AuthContext.Provider value={authContextValue}>
      <DianaCoreProvider theme={theme}>
        <div className="app-container">
          <Outlet />
        </div>
      </DianaCoreProvider>
    </AuthContext.Provider>
  );
}

export default App;
